import React from 'react';
import {AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig} from 'remotion';
import {COLORS,FONTS} from '../../coldcompute/theme';
import episodes from './episodes.json';

export const NotebookScene:React.FC<{episode:number;scene:number;thumbnail?:boolean}>=({episode,scene,thumbnail=false})=>{
 const frame=useCurrentFrame();const {fps}=useVideoConfig();const item=episodes[episode],beat=item.scenes[scene];
 const proof=item.sources[Math.min(scene===2?1:0,item.sources.length-1)];
 const code=beat.kind==='Source walkthrough';
 const enter=thumbnail?1:spring({frame,fps,config:{damping:200,stiffness:160,mass:.6}});
 const scale=thumbnail?1:1.5;
 return <AbsoluteFill style={{background:COLORS.bg}}><div style={{position:'absolute',width:1280,height:720,transform:`scale(${scale})`,transformOrigin:'top left',overflow:'hidden',background:`radial-gradient(120% 120% at 50% 0%,#0e1320,${COLORS.bg} 60%,${COLORS.bg2})`,color:COLORS.text,fontFamily:FONTS.body,padding:'42px 54px'}}>
  <AbsoluteFill style={{opacity:.05,backgroundImage:`linear-gradient(90deg,${COLORS.cyan} 1px,transparent 1px)`,backgroundSize:'8.333% 100%'}}/>
  <div style={{position:'relative',display:'flex',justifyContent:'space-between',fontSize:13,letterSpacing:1.5,color:COLORS.dim}}><span>EAKC / BUILDER'S NOTEBOOK / {item.number}</span><span style={{color:COLORS.amber}}>REVIEW DRAFT · AI NARRATION</span></div>
  <h1 style={{position:'relative',fontFamily:FONTS.display,fontSize:49,lineHeight:1.08,fontWeight:700,margin:'30px 0 28px',maxWidth:1120,height:112,opacity:enter,transform:`translateY(${(1-enter)*16}px)`}}>{thumbnail?item.title:beat.title}</h1>
  <div style={{position:'relative',display:'grid',gridTemplateColumns:'1fr 1.05fr',gap:28,height:335,opacity:enter}}>
   <div style={{background:COLORS.panel,border:`1px solid ${COLORS.line}`,borderRadius:18,padding:28}}>
    <div style={{color:COLORS.cyan,fontFamily:FONTS.mono,fontSize:14,letterSpacing:2,marginBottom:28}}>{beat.kind.toUpperCase()}</div>
    {beat.bullets.map((b,i)=>{const reveal=thumbnail?1:interpolate(frame,[8+i*7,18+i*7],[0,1],{extrapolateLeft:'clamp',extrapolateRight:'clamp'});return <div key={b} style={{display:'flex',alignItems:'center',gap:16,marginBottom:23,fontSize:25,lineHeight:1.22,opacity:reveal,transform:`translateX(${(1-reveal)*10}px)`}}><span style={{flexShrink:0,width:36,height:36,borderRadius:18,background:'#123239',color:COLORS.cyan,textAlign:'center',fontSize:18,lineHeight:'36px'}}>{i+1}</span><span>{b}</span></div>})}
   </div>
   <div style={{background:COLORS.panel2,border:`1px solid ${COLORS.line}`,borderRadius:18,padding:26,overflow:'hidden'}}>
    <div style={{fontFamily:FONTS.mono,fontSize:13,color:COLORS.dim,letterSpacing:1,marginBottom:24}}>{code?'INSPECTED SOURCE · 42306376':'EXPLANATORY DIAGRAM · NOT A LIVE TRACE'}</div>
    {code?<pre style={{fontFamily:FONTS.mono,fontSize:17,lineHeight:1.5,whiteSpace:'pre-wrap',overflowWrap:'anywhere',margin:0,color:COLORS.green}}>{proof.excerpt}</pre>:<div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:20}}>{beat.bullets.map((b,i)=><div key={b} style={{background:'#0c1e26',border:`1px solid ${i===2?COLORS.green:COLORS.cyan}`,borderRadius:12,width:'94%',padding:'18px 12px',textAlign:'center',fontSize:22,lineHeight:1.15}}>{b}</div>)}</div>}
   </div>
  </div>
  <div style={{position:'absolute',top:208,left:54,right:54,fontSize:12,color:COLORS.dim,display:'flex',justifyContent:'space-between',gap:20}}><span style={{maxWidth:1000}}>SOURCE: {proof.path}:{proof.line} · commit 42306376</span><span>{scene+1} / 4</span></div>
  <div style={{position:'absolute',top:229,left:54,right:54,height:2,background:COLORS.line}}><div style={{width:`${(scene+1)*25}%`,height:2,background:COLORS.cyan}}/></div>
 </div></AbsoluteFill>
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
